import { Outlet } from "react-router";
import { Sidebar } from "./Sidebar";
import { Topbar } from "./Topbar";
import { CommandPalette } from "./CommandPalette";
import { LayoutProvider, useLayout } from "./LayoutContext";
import { CreateEventDialog } from "@/components/events/CreateEventDialog";
import { CreateParentEventDialog } from "@/components/parent-events/CreateParentEventDialog";
import { CreateCategoryDialog } from "@/components/categories/CreateCategoryDialog";
import { CreateVenueDialog } from "@/components/venues/CreateVenueDialog";
import { CreateMovieDialog } from "@/components/movies/CreateMovieDialog";
import { useAuth } from "@/context/AuthContext";
import { cn } from "@/lib/utils";

function LayoutShell() {
  const { mobileOpen, setMobileOpen, quickAdd, setQuickAdd } = useLayout();
  const { userRole } = useAuth();
  const isAdmin = userRole === "admin";

  return (
    // h-screen + overflow-hidden makes the shell a fixed viewport so the
    // sidebar (and its sticky footer) stay pinned; only <main> scrolls.
    <div className="flex h-screen overflow-hidden bg-pulso-bg">
      {/* Desktop sidebar */}
      <div className="hidden lg:block">
        <Sidebar />
      </div>

      {/* Mobile slide-over sidebar */}
      <div
        className={cn(
          "fixed inset-0 z-50 lg:hidden",
          mobileOpen ? "pointer-events-auto" : "pointer-events-none",
        )}
      >
        <div
          className={cn(
            "absolute inset-0 bg-black/45 transition-opacity",
            mobileOpen ? "opacity-100" : "opacity-0",
          )}
          onClick={() => setMobileOpen(false)}
        />
        <div
          className={cn(
            "absolute left-0 top-0 h-full shadow-xl transition-transform duration-200",
            mobileOpen ? "translate-x-0" : "-translate-x-full",
          )}
        >
          <Sidebar />
        </div>
      </div>

      <div className="flex min-w-0 flex-1 flex-col">
        <Topbar />
        <main className="flex-1 overflow-auto p-4 sm:p-6 lg:p-8">
          <Outlet />
        </main>
      </div>

      <CommandPalette />
      {isAdmin && (
        <>
          <CreateEventDialog
            open={quickAdd === "event"}
            onOpenChange={(o) => setQuickAdd(o ? "event" : null)}
          />
          <CreateParentEventDialog
            open={quickAdd === "parent-event"}
            onOpenChange={(o) => setQuickAdd(o ? "parent-event" : null)}
          />
          <CreateCategoryDialog
            open={quickAdd === "category"}
            onOpenChange={(o) => setQuickAdd(o ? "category" : null)}
          />
          <CreateVenueDialog
            open={quickAdd === "venue"}
            onOpenChange={(o) => setQuickAdd(o ? "venue" : null)}
          />
          <CreateMovieDialog
            open={quickAdd === "movie"}
            onOpenChange={(o) => setQuickAdd(o ? "movie" : null)}
          />
        </>
      )}
    </div>
  );
}

export function AppLayout() {
  return (
    <LayoutProvider>
      <LayoutShell />
    </LayoutProvider>
  );
}
